var map = {
	"./01-min.jpg": "5901",
	"./02-min.jpg": "04e8",
	"./03-min.jpg": "9beb",
	"./04-min.jpg": "e1ce",
	"./05-min.jpg": "64b6",
	"./06-min.jpg": "4eaf",
	"./07-min.jpg": "6916",
	"./08-min.jpg": "7d25",
	"./09-min.jpg": "65e4",
	"./10-min.jpg": "c2a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a334";